import React, { useRef } from "react";

import { Header, List, Popup, Image } from "semantic-ui-react";

const BuyboxMarkupLegend = () => {
  const ref = useRef(null);

  const listItemStyle = {
    fontSize: "0.9rem", // Adjust the font size as needed
    display: "flex",
    alignItems: "center",
  };
  const iconStyle = {
    marginRight: "8px",
    maxWidth: "20px",
  };

  return (
    <Popup
      closeOnPortalMouseLeave
      style={{ width: "400px" }}
      flowing
      ref={ref}
      trigger={<p>Buybox Markup</p>}
    >
      <Header as="h2" id="buybox-markup-legend-tooltip">
        BuyBox Markup Legend
      </Header>

      <p>
        BuyBox Markup compares the current buybox price to the cheapest possible
        combination of buybox prices that can form an equivalent product.
      </p>

      <Header as="h4" style={{ marginTop: "1em", marginBottom: "0.5em" }}>
        Formula
      </Header>
      <p
        style={{
          fontFamily: "monospace",
          backgroundColor: "#f5f5f5",
          padding: "8px",
          borderRadius: "4px",
        }}
      >
        (BuyBox Price - Cost Basis) / Cost Basis
      </p>

      <Header as="h4" style={{ marginTop: "1em", marginBottom: "0.5em" }}>
        Eligibility Criteria
      </Header>
      <p style={{ marginBottom: "0.5em" }}>
        Products must meet all of the following:
      </p>
      <List bulleted size="small">
        <List.Item>New (no used products)</List.Item>
        <List.Item>Fulfilled by Amazon (FBA)</List.Item>
        <List.Item>Has a BuyBox Price</List.Item>
        <List.Item>
          Minimum Ship Speed of 144 hours or less (Fast/Medium)
        </List.Item>
      </List>

      <Header as="h4" style={{ marginTop: "1em", marginBottom: "0.5em" }}>
        Included Products
      </Header>
      <p>The following products will be considered:</p>
      <List bulleted size="small">
        <List.Item>Equivalent or potential sub-component listings</List.Item>
        <List.Item>Linked inventory units</List.Item>
      </List>

      <Header as="h3">Statuses:</Header>
      <List bulleted relaxed>
        <List.Item style={listItemStyle}>
          <Image src="https://i.ibb.co/Nsdhbrz/1.png" style={iconStyle} />
          <div>
            <b>Missing</b> - Quantity of required pieces that weren't valid for
            calculation (number not shown for single piece listings)
          </div>
        </List.Item>
        <List.Item style={listItemStyle}>
          <Image
            src="https://i.ibb.co/m9Dj2FY/Green-Arrow.png"
            style={iconStyle}
          />
          <div>
            <b>Premium</b> - Percentage the item is marked up compared to
            equivalents/components
          </div>
        </List.Item>
        <List.Item style={listItemStyle}>
          <Image
            src="https://i.ibb.co/pXbvMqQ/Red-Arrow.png"
            style={iconStyle}
          />
          <div>
            <b>Discount</b> - Percentage the item is discounted compared to
            equivalents/components
          </div>
        </List.Item>
        <List.Item style={listItemStyle}>
          <b style={{ fontSize: 30, paddingRight: "6px", fontWeight: "bold" }}>
            &#8734;
          </b>
          <div>
            <b>Ineligible with options</b> - Item is ineligible for calculation
            but has eligible equivalents/components
          </div>
        </List.Item>
        <List.Item style={listItemStyle}>
          <span
            style={{
              color: "purple",
              fontSize: 12,
              paddingRight: "6px",
              fontWeight: "bold",
              whiteSpace: "nowrap",
              display: "inline-block",
            }}
          >
            N/A
          </span>
          <div>
            <b>Not applicable</b> - Item is ineligible for calculation and has
            no eligible equivalents/components
          </div>
        </List.Item>

        <List.Item style={listItemStyle}>
          <b>PAR</b> - Equal to the cost-basis for calculation
        </List.Item>
      </List>
    </Popup>
  );
};

export default BuyboxMarkupLegend;
